/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExistingClientResponseListBaseResponse as ModelsV3LoanManagementExistingClientResponseListBaseResponse } from '../../models/Models/v3/LoanManagement/existing-client-response-list-base-response';

export interface V3LoanManagementClientsGet$Plain$Params {
  firstName?: string;
  lastName?: string;
  dob?: string;
  email?: string;
  mobile?: string;
}

export function v3LoanManagementClientsGet$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementClientsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('dob', params.dob, {});
    rb.query('email', params.email, {});
    rb.query('mobile', params.mobile, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListBaseResponse>;
    })
  );
}

v3LoanManagementClientsGet$Plain.PATH = '/v3/loan-management/clients';
